module.exports = __webpack_public_path__ + "static/media/Currently Supported Dashboards.cba0e394.csv";